import { Box, Grid, Typography } from '@mui/material'
import { StyledPageTitle } from './CommonStyles'
import IntroCard from './plans/IntroCard'
import FeatureCard from './plans/FeatureCard'
import styled from '@emotion/styled'
import ConstructionBlock from './plans/ConstructureBlock'

import iconDeviceEyes from '../assets/03_feature/01設備監控.png'
import iconMachineHistory from '../assets/03_feature/02機台狀態歷史堆疊圖.png'
import iconUpDownload from '../assets/03_feature/03加工程式上下傳.png'
import iconReportMngm from '../assets/03_feature/04稼動管理.png'
import iconAlertResume from '../assets/03_feature/05機台警報履歷.png'
import iconToolLifeResume from '../assets/03_feature/06刀具壽命履歷管理.png'
import iconAIToolCheck from '../assets/03_feature/07AI刀具診斷.png'
import iconAIFault from '../assets/03_feature/08AI故障預測.png'
import  useRWD  from '../utils/useRWD'

export const featureContent = [
  {
    title: '設備監控',
    imgSrc: iconDeviceEyes,
    descipt: [
      '即時顯示機台運行狀態，包括開機、停機、待機與異常資訊。',
      '提供生產數據的即時更新，確保管理層能夠隨時掌握設備運行狀況。',
    ],
  },
  {
    title: '機台狀態歷史堆疊圖',
    imgSrc: iconMachineHistory,
    descipt: [
      '透過圖表化方式呈現設備的歷史運行數據，幫助企業進行長期趨勢分析。',
      '追蹤關鍵生產參數變化，協助預測設備故障與維護需求。',
    ],
  },
  {
    title: '加工程式上下傳',
    imgSrc: iconUpDownload,
    descipt: [
      'CNC 設備的加工程式可透過平台遠端上傳與下載，提高程式管理的效率與安全性。',
      '避免因手動傳輸導致的版本錯誤或資料遺失。',
    ],
  },
  {
    title: '稼動管理',
    imgSrc: iconReportMngm,
    descipt: [
      '監控各機台的稼動率，確保生產效率達到最佳化。',
      '提供可視化數據報表，分析設備利用率與瓶頸點。',
    ],
  },
  {
    title: '機台警報履歷',
    imgSrc: iconAlertResume,
    descipt: [
      '記錄所有異常狀況與警報資訊，包括時間、原因與處理方式。',
      '協助技術人員快速診斷問題並追蹤歷史維護紀錄，提高設備維護效率。',
    ],
  },
  {
    title: '刀具壽命履歷管理',
    imgSrc: iconToolLifeResume,
    descipt: [
      '追蹤刀具使用歷程，根據數據計算更換週期，減少生產中斷。',
      '確保刀具壽命管理透明化，提高刀具使用效率。',
    ],
  },
  {
    title: 'AI刀具診斷',
    imgSrc: iconAIToolCheck,
    descipt: [
      '透過 AI 分析刀具磨損情況，提前預測更換時機。',
      '降低刀具損壞風險與維護成本，提高生產品質。',
    ],
  },
  {
    title: 'AI故障預測',
    imgSrc: iconAIFault,
    descipt: [
      '透過機器學習分析異常數據，提前預測設備故障。',
      '降低維護成本，確保生產流程順暢運行',
    ],
  },
]


export default function Plans() {
  const { isPC, isToplet, isPhone } = useRWD()

  function getFeatureCardXS() {
    if (isPC) {
      return 3
    } else if (isToplet) {
      return 6
    } else if (isPhone) {
      return 12
    }
  }
  return (
    <div>
      <Grid container spacing={6} textAlign="center">
        {/* 說明 */}
        <Grid item xs={12} >
          <Typography variant="h2">解決方案</Typography>
          <Typography variant="subtitle1">
            <b>智能聯網解決方案：</b>讓老舊設備也能數位化！
          </Typography>
          <Typography variant="subtitle1">
            提供一站式智慧分析平台，讓您一目了然工廠各式機台生產狀態！
          </Typography>
        </Grid>
        {/* 方案功能與優勢 */}
        <Grid item xs={12}>
          <Typography variant="h3">方案功能與優勢</Typography>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <IntroCard />
          </Box>
        </Grid>
        {/* 方案架構 */}
        <Grid item xs={12}>
          <Typography variant="h3">方案架構</Typography>
          <ConstructionBlock />
        </Grid>
        {/* 方案功能 */}
        <Grid item xs={12}>
          <Typography variant="h3">方案功能</Typography>
          <Grid container spacing={isPC ? 6 : 12} justifyContent="center">
            {featureContent.map((item, i) => (
              <Grid key={i} item xs={getFeatureCardXS()}>
                <FeatureCard {...item} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
